import { useRef, useEffect } from "react";
import { consumer } from "../../../helpers/consumer";
// Custom hook to subscribe and unsubscribe to Action Cable channel
export default function useDiscussionChannel(discussionId, setMessages, setUsersInfo, loaded, componentRef) {
  const subscription = useRef(null);

  const disconnectChannel = () => {
    if (subscription.current){
        consumer.subscriptions.remove(subscription.current);
        subscription.current = null;
      }
  }
  const initChannel = () => {
    if (!discussionId) return;
    if (!loaded || !componentRef) {
      disconnectChannel();
      return
    };
    subscription.current = consumer.subscriptions.create(
      { 
        channel: 'LiveDiscussionChannel',
        discussion_id: discussionId
      },
      {
        connected() {},

        received(request) {
            if (!discussionId) return;
            const data = request.data
            if (request.type === 'refresh_message'){
              const newMessages = Array.isArray(data) ? data : [data];
              const oldestMessageId = newMessages.length > 0 ? newMessages[0].id : null
              if (oldestMessageId){
                setMessages(messages => {
                  let oldestMessageIdx = null;
                  for (let i = messages.length-1; i > 0; i--){
                      if (messages[i].id === oldestMessageId){
                          oldestMessageIdx = i;
                          break;
                      }
                  }
  
                  const nonOutdatedMessages = messages.slice(0,oldestMessageIdx)
                  return [...nonOutdatedMessages, ...newMessages];
              });
              }
            } else if (request.type === 'new_user'){
              setUsersInfo(prev => ({
                ...prev,
                ...(data || {})
              }))
            }
        },

        reloadMessages: (latest_message_id) => {
          subscription.current.send({ command: 'refresh', discussion_id: discussionId, message_id: latest_message_id });
        },
      }
    );

    return disconnectChannel;
  }

  useEffect(initChannel, [discussionId, loaded]);

  return subscription;
}
